module.exports = __webpack_public_path__ + "static/media/P20-sm-open.73a99a75.svg";